import { render, staticRenderFns } from "./card-ticket-see.vue?vue&type=template&id=64fae516&scoped=true&"
import script from "./card-ticket-see.vue?vue&type=script&lang=js&"
export * from "./card-ticket-see.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fae516",
  null
  
)

export default component.exports